import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import MultiplyByA from './MultiplyByA/MultiplyByA'
import TimesTable4x4 from './TimesTable4x4/TimesTable4x4'

const Bootcamp2Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'TimesTable4x4':
      return <TimesTable4x4 {...props} />
    case 'MultiplyByA':
      return <MultiplyByA {...props} />
    default:
      return <></>
  }
}

export default Bootcamp2Activities
